import { configureStore } from '@reduxjs/toolkit'
import orgReducer from './slices/orgSlice'
import userReducer from './slices/userSlice'
import navReducer from './slices/navSlice'
import rolesReducer from './slices/rolesSlice'
import loaderReducer from './slices/loaderSlice'
import entityReducer from './slices/entitySlice'
import entityInstanceReducer from './slices/entityInstanceSlice'
import dtStudioReducer from './slices/dtStudioSlice'
import facilityMonitoringReducer from './slices/facilityMonitoringSlice'
import inTransitReducer from './slices/inTransitSlice'
import entityViewSlice from './slices/entityViewSlice'
import programReducer from './slices/programSlice'
import searchParamReducer from './slices/searchParamsSlice'
import deviceManagerReducer from './slices/deviceManagerSlice'
import alertsReducer from './slices/alertSlice'

export const store = configureStore({
    reducer: {
        org: orgReducer,
        user: userReducer,
        nav: navReducer,
        roles: rolesReducer,
        loader: loaderReducer,
        entity: entityReducer,
        alerts: alertsReducer,
        entityInstance: entityInstanceReducer,
        dtStudio: dtStudioReducer,
        facilityMonitoring: facilityMonitoringReducer,
        inTransit: inTransitReducer,
        entityInstanceView: entityViewSlice,
        program: programReducer,
        searchParams: searchParamReducer,
        deviceManager: deviceManagerReducer,
    },
    devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
